import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';

import { ENV_VARS, STAGE } from 'ENV_CONFIG';
import {
  clearSelectedFacets,
  clearRouteConfig,
  restoreAnalyticsDataLayer,
  historyErrorState,
  cancelAbortableRequests,
} from './middlewares';

export const addLogger = (stage) => {
  switch (stage) {
    case STAGE.LOCAL:
    case STAGE.DEV:
    case STAGE.TEST:
      return [
        createLogger({
          collapsed: () => true,
        }),
      ];
    default:
      return [];
  }
};

const draftMiddleware = [
  thunk,
  clearSelectedFacets,
  clearRouteConfig,
  restoreAnalyticsDataLayer,
  historyErrorState,
  cancelAbortableRequests,
].concat(addLogger(ENV_VARS.REACT_APP_STAGE));

const middleware = applyMiddleware(...draftMiddleware);

export { middleware };
